import JSZip from 'jszip';

export const  downloadImagesAsZip = async (imagesArray) => {
    const zip = new JSZip();
    const imageUrls = imagesArray; // Replace with your image URLs

    // Fetch images and add them to the zip file
    await Promise.all(
      imageUrls.map(async (imageUrl, index) => {
        const response = await fetch(imageUrl);
        const arrayBuffer = await response.arrayBuffer();
        zip.file(`image_${index + 1}.jpg`, arrayBuffer);
      })
    );

    // Generate the zip file
    const content = await zip.generateAsync({ type: 'blob' });

    // Create a download link and trigger the download
    const link = document.createElement('a');
    link.href = URL.createObjectURL(content);
    link.download = 'images.zip';
    link.click();
}
